const url = window.location
const BASE_URL = url.protocol + "//" + url.host + "/" + url.pathname.split('/')[0]
const CLIENT_ID = '743457703749484587'

export {BASE_URL, CLIENT_ID};